export enum OrganisationCategory {
 Trader,
 Workshop,
 Retailer,
 Distributor
}
